export default "__VITE_ASSET__CgCAEke7__"